import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
export interface AppConfig {
  apiBaseUrl: string;
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private http = inject(HttpClient);

  // Use a signal to store config for easy access
  private configSignal = signal<AppConfig | null>(null);

  // Getter for the rest of the app
  get settings() {
    const current = this.configSignal();
    if (!current) throw new Error('Config not loaded!');
    return current;
  }

  // This method will be called during app startup
  loadConfig(): Promise<void> {
    // Determine which file to load based on environment.ts
    const fileName = (environment as any).configFile || 'config.dev.json';
    const configPath = `/assets/config/${fileName}`;

    return firstValueFrom(this.http.get<AppConfig>(configPath)).then((config) => {
      this.configSignal.set(config);
    });
  }
}
